import { useQuery } from "react-query";
import { getDashboardCounts } from "../Services/Https/dashboard";

export const useDashboardCounts = () => {
  return useQuery(["dashboard"], () => getDashboardCounts(), {
    keepPreviousData: true,
  });
};
